<template>
    <div class="record-vehicle loading-content-container">
        <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
            <csp-loading-indicator/>
        </div>
        <div v-if="!isLoading">
            <b-row>
                <b-col cols="8">
                    <b-row>
                        <csp-desktop-vehicle-basedata
                            :form-context="initialFormContexts.vehicleBasedata"/>
                    </b-row>
                </b-col>
                <b-col :cols="4">
                    <b-row>
                        <csp-desktop-info-card v-if="canShowGallery" :cols="12" icon="inticon-documents"
                            title="Fahrzeugdokumente / -bilder">
                            <div class="loading-content-container">
                                <div v-if="galleryIsLoading" class="loading-overlay d-flex justify-content-center">
                                    <csp-loading-indicator/>
                                </div>
                                <div v-if="!galleryIsLoading">
                                    <div v-if="galleryFiles.length > 0 && galleryActiveIndex != null"
                                        class="preview collapse-body mb-5" style="height: 450px;">
                                        <div v-show="galleryActiveTitle" class="galleryActiveTitle text-center mb-4">
                                            {{ galleryActiveTitle }}
                                        </div>
                                        <csp-file-gallery :active-index="galleryActiveIndex"
                                            :files="galleryFiles"
                                            :height="400"
                                            :width="400 / 1.414"
                                            @change="onGalleryChange"/>
                                    </div>

                                    <b-alert v-if="galleryFiles.length == 0" show variant="info">
                                        Keine Fahrzeugdokumente oder -bilder vorhanden.
                                    </b-alert>
                                </div>
                            </div>
                        </csp-desktop-info-card>
                    </b-row>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '../mixins/FormDataMixin';
    import VehicleBasedata from '@desktop/components/record/vehicle/VehicleBasedata.vue';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();
    const recordRepositoryShared = container.getRecordRepository();

    export default {
        name: 'RecordVehicle',
        components: {
            'csp-desktop-vehicle-basedata': VehicleBasedata,
        },
        mixins: [FormDataMixin],
        data() {
            const recordId = this.$route.params.recordId;
            return {
                recordId,
                initialFormContexts: {
                    vehicleBasedata: new FormContext({
                        name: 'vehicleBasedata',
                        objectId: recordId,
                        reloadFields: [],
                    }),
                },
                galleryActiveIndex: null,
                galleryFiles: [],
                currentGalleryFile: null,
                isLoading: true,
                galleryIsLoading: true,
                canShowGallery: false,
            }
        },
        computed: {
            galleryActiveTitle() {
                if (!this.currentGalleryFile) return ''
                return this.currentGalleryFile.category + ' - ' + this.currentGalleryFile.name
            },
        },
        created() {
            this.loadVehicleBasedata().finally(() => {
                if (this.canShowGallery) {
                    this.loadGalleryFiles();
                }
            });
        },
        methods: {
            async loadVehicleBasedata() {
                this.initialFormContexts.vehicleBasedata.isLoaded = false;
                const loadFunction = () => {
                    return recordRepository.loadVehicleOverview(this.recordId);
                }

                return this.loadFormData(loadFunction).then((success) => {
                    this.canShowGallery = success.data.meta.permissions.canShowVehicleGallery;
                }).finally(() => {
                    this.isLoading = false;
                })
            },
            onGalleryChange(galleryActiveIndex) {
                this.currentGalleryFile = this.galleryFiles[galleryActiveIndex]
                this.galleryActiveIndex = galleryActiveIndex
            },
            loadGalleryFiles() {
                return recordRepositoryShared.getVehicleThumbnailData(this.recordId, 'carousel').then(
                    (data) => {
                        data.data.forEach(fileThumbnail => {
                            const thumbnailAttributes = fileThumbnail.attributes;
                            const fileId = thumbnailAttributes.fileId;

                            this.galleryFiles.push({
                                fileId: thumbnailAttributes.fileId,
                                thumbnailId: thumbnailAttributes.thumbnailId,
                                name: thumbnailAttributes.fileName,
                                category: thumbnailAttributes.fileCategoryName,
                                thumbnailUrl: recordRepositoryShared.buildThumbnailDownloadUrl(
                                    this.recordId, fileId, 'carousel'
                                ),
                                url: recordRepositoryShared.buildFileDownloadUrl(this.recordId, fileId),
                            });
                        });
                        this.galleryIsLoading = false;
                        if (this.galleryFiles.length > 0) {
                            this.onGalleryChange(0)
                        } else {
                            this.galleryActiveIndex = null;
                            this.currentGalleryFile = null;
                        }
                    }
                );
            },
        },
    }
</script>
